var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("portal", { attrs: { to: "content-header-right" } }, [
    _c(
      "div",
      { staticClass: "panel-toolbar" },
      [
        _c(
          "button",
          {
            staticClass: "panel-toolbar__eye",
            attrs: {
              type: "button",
              "aria-label": _vm.$t("influencer_panel.toggle_money"),
              title: _vm.$t("influencer_panel.toggle_money"),
            },
            on: { click: _vm.toggleMoney },
          },
          [
            _c("feather-icon", {
              attrs: {
                icon: _vm.moneyHidden ? "EyeOffIcon" : "EyeIcon",
                size: "16",
              },
            }),
          ],
          1
        ),
        _vm.showPeriod
          ? _c("b-form-select", {
              staticClass: "panel-toolbar__period",
              attrs: {
                value: _vm.period,
                options: _vm.periodOptions,
                size: "sm",
                "aria-label": _vm.$t("influencer_panel.period"),
              },
              on: {
                change: function ($event) {
                  return _vm.$emit("update:period", $event)
                },
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }